import React, { type MouseEvent } from 'react';

import { useNavigate } from 'react-router-dom';

import { ReactComponent as CloseIcon } from '@pkg/assets/icons/v2/close.svg';
import { type ButtonIcon } from '@pkg/components/Sections/Profile/Buttons';

import { type Color } from '../ButtonBase';

import { type position, StyledYatButton, StyledYatMagnetism } from './styles';

type Props = Omit<React.ComponentProps<typeof ButtonIcon>, 'children' | 'color'> & {
    className?: string;
    ariaLabel?: string;
    icon?: React.ReactElement;
    magnetize?: boolean;
    absolutelyPosition?: position;
    back?: boolean;
    color?: Color;
};

export const ButtonBack = ({
    className,
    to,
    icon,
    ariaLabel,
    magnetize,
    absolutelyPosition,
    back = false,
    color = 'translucent',
    ...rest
}: Props) => {
    const navigate = useNavigate();

    const goToPreviousPage = () => navigate(-1);

    const handleClick = (event: MouseEvent<HTMLElement>) => {
        if (rest.onClick) rest.onClick(event);
        if (back) goToPreviousPage();
    };

    const Button = (
        <StyledYatButton
            className={className}
            to={!!to && !back ? to : undefined}
            onClick={handleClick}
            color={color}
            aria-label={ariaLabel}
            $absolutelyPosition={magnetize ? undefined : absolutelyPosition}
            {...rest}
        >
            {icon ? icon : <CloseIcon />}
        </StyledYatButton>
    );

    return magnetize ? (
        <StyledYatMagnetism $absolutelyPosition={absolutelyPosition} className="magnetism-container">
            {Button}
        </StyledYatMagnetism>
    ) : (
        Button
    );
};
